import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { toNumber, toString, toSafeInteger } from 'lodash';
import {
  Form, Button, Modal, Icon, Message,
} from 'semantic-ui-react';
import Validator from 'validatorjs';

class GuaranteePurchaseExtend extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: '',
      extensionDays: 0,
      extensionReason: '',
      errors: {},
    };
  }

  componentDidMount() {
    const { guaranteePurchase } = this.props;
    const { id, extensionDays, extensionReason } = guaranteePurchase;

    this.setState({
      id: toNumber(id),
      extensionDays: toSafeInteger(extensionDays),
      extensionReason: toString(extensionReason),
    });
  }

  render() {
    const {
      guaranteePurchase,
      isModalOpen,
      onCloseHandler,
      onSubmitHandler,
      error,
      submitting,
    } = this.props;

    const {
      id,
      extensionDays,
      extensionReason,
      errors,
    } = this.state;

    const onChangeHandler = field => event => {
      this.setState({ [field]: event.target.value });
    };

    const validationRules = {
      extensionDays: 'numeric|customDays',
    };

    Validator.register(
      'customDays',
      value => {
        return value >= 0;
      },
      'Should be a positive number.'
    );

    const submitForm = () => {
      const validation = new Validator(this.state, validationRules);
      if (validation.fails()) {
        this.setState({ errors: validation.errors.all() });
        return false;
      }
      this.setState({ errors: {} });
      onSubmitHandler({
        id: parseInt(id, 10),
        extensionDays: parseInt(extensionDays, 10),
        extensionReason,
      });
      return true;
    };

    const {
      expiresAt,
      guaranteeOffer: { vehicleInformation: { vin } },
    } = guaranteePurchase;

    return (
      <Modal
        open={isModalOpen}
        closeIcon
        onClose={onCloseHandler}
        closeOnEscape={false}
        closeOnRootNodeClick={false}
      >
        <Modal.Header>Guarantee Extension for VIN {vin}</Modal.Header>
        <Modal.Content image>
          <Modal.Description>
            {error && (
              <Message negative>
                <Message.Header>
                  Error while updating guarantee purchase
                </Message.Header>
                <p>{error}</p>
              </Message>
            )}
            <Form>
              <Form.Group widths='equal'>
                <Form.Field>
                  <label htmlFor='expiresAt'>Current Expiration Date</label>
                  <input id='expiresAt' name='expiresAt' disabled value={expiresAt} />
                </Form.Field>
              </Form.Group>
              <Form.Group widths='equal'>
                <Form.Field>
                  <label htmlFor='extensionDays'>Extension Days</label>
                  <input
                    id='extensionDays'
                    type='text'
                    onKeyPress={event => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    name='extensionDays'
                    value={extensionDays}
                    onChange={onChangeHandler('extensionDays')}
                  />
                  {errors.extensionDays && (
                    <span style={{ color: 'red' }}>{errors.extensionDays}</span>
                  )}
                </Form.Field>
              </Form.Group>

              <Form.Group widths='equal'>
                <Form.Field>
                  <label htmlFor='extensionReason'>Extension Reason</label>
                  <input
                    id='extensionReason'
                    name='extensionReason'
                    value={extensionReason}
                    onChange={onChangeHandler('extensionReason')}
                  />
                </Form.Field>
              </Form.Group>
            </Form>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          {submitting && (
            <Button loading positive>
              Submitting...
            </Button>
          )}
          {!submitting && (
            <Button color='green' onClick={submitForm} inverted>
              <Icon name='checkmark' /> Update
            </Button>
          )}
          <Button onClick={onCloseHandler}>Cancel</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

GuaranteePurchaseExtend.propTypes = {
  guaranteePurchase: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    extensionDays: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    extensionReason: PropTypes.string,
    expiresAt: PropTypes.string,
    guaranteeOffer: PropTypes.shape({
      vehicleInformation: PropTypes.shape({
        vin: PropTypes.string,
      }),
    }),
  }).isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  onCloseHandler: PropTypes.func.isRequired,
  onSubmitHandler: PropTypes.func.isRequired,
  error: PropTypes.string,
  submitting: PropTypes.bool,
};

GuaranteePurchaseExtend.defaultProps = {
  error: null,
  submitting: false,
};

export default GuaranteePurchaseExtend;
